import type { PresenceUser } from '../types'
import { apiFetch } from './core'

export async function getPresence(): Promise<PresenceUser[]> {
  return apiFetch<PresenceUser[]>('/api/presence')
}
